<template>
  <div
    v-if="$store.getters.marchand && $store.getters.marchand._env === 'live'"
    class="row"
    style="padding: 5px"
  >
    <div class="col-12 mb-4">
      <div class="col-12 mb-4">
        <div class="pb-4">
          <v-btn
            @click="$router.go(-1)"
            outlined
            style="border: none; background: #fff"
            title="Retourner"
          >
            <v-icon>mdi mdi-arrow-left-thin</v-icon> Retour
          </v-btn>
        </div>
      </div>
      <v-card elevation="0">
        <div>
          <v-form>
            <v-row>
              <v-col lg="4" sm="6">
                <router-link
                  :to="{
                    name: 'intramScholar.classes',
                    params: { school_id: this.$route.params.school_id },
                  }"
                  class="box-business"
                >
                  <img src="/images/class.png" alt="intram-product" />
                  <h4>{{ $t("menus.classes") }}</h4>
                </router-link>
              </v-col>

              <v-col lg="4" sm="6">
                <router-link
                  :to="{
                    name: 'intramScholar.fees',
                    params: { school_id: this.$route.params.school_id },
                  }"
                  class="box-business"
                >
                  <img src="/images/scholar-fees.png" alt="intram-client" />
                  <h4>{{ $t("menus.fees") }}</h4>
                </router-link>
              </v-col>

              <v-col lg="4" sm="6">
                <router-link
                  :to="{
                    name: 'intramScholar.instalments',
                    params: { school_id: this.$route.params.school_id },
                  }"
                  class="box-business"
                >
                  <img src="/images/settings.png" alt="intram-transaction" />
                  <h4>{{ $t("menus.instalments") }}</h4>
                </router-link>
              </v-col>
            </v-row>
          </v-form>
        </div>
        <v-col> </v-col>
      </v-card>
    </div>
  </div>
  <div v-else>
    <go-to-params></go-to-params>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  label: "schoolSettings",
  mounted() {},
  methods: {
    checkisDashboard() {
      this.$emit("checkisDashboard", true);
    },
  },
  created() {
    this.checkisDashboard();
  },
};
</script>

<style scoped>
.box-business img {
  width: 200px;
  margin-bottom: 20px;
}
.box-business:hover {
  transition-duration: 500ms;
  transition-property: background-color;
  background-color: #ccc;
}
.box-business h4 {
  text-decoration: none;
}
.box-business {
  display: block;
  background: #fff;
  text-align: center;
  padding: 30px;
  cursor: pointer;
  box-shadow: 0px 4px 12px rgb(39 48 57 / 5%);
  border-radius: 8px;
}
</style>
